<ng-template #videoViewerModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{title}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeVideoViewerModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="col-md-12 text-center">
            <video width="100%" height="400" controls>
                <source [src]="videoUrl" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-md-12 text-right">
                <button type="button" class="btn btn-outline-dark" (click)="closeVideoViewerModal()">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>